import { sendRequestAuth } from 'api/api'
import { removeAcent } from 'common/fieldText/_functions'
import { convertDateTimeToApiFormat } from 'common/form/datePicker/_functions'
import config from 'config'
import { useCallback, useContext } from 'react'
import { DateRangePicker } from 'rsuite'
import {
  STUDENT_FILTER_TAG_FIELDS,
} from '../interfaces/_constants'
import { StudentContext } from '../provider/_context'
import { studentActions } from '../provider/_reducer'
import { studentInitialState } from '../provider/_initState'
import { useSearchParams } from 'react-router-dom'

export const useHistoryStudentFilterForm = (data) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { pageState, pageDispatch } = useContext(StudentContext)
  const { table } = pageState
  const { orderHistory } = table
  const { filter } = orderHistory

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  // ===== ===== ===== ===== =====
  // DATE TIME
  // ===== ===== ===== ===== =====
  const { afterToday } = DateRangePicker
  const dateTimeActiveValue = filter.dateTime.activeValue
  const dateTimeEnd = filter.dateTime.end
  const dateTimeStart = filter.dateTime.start
  const dateTimeDefaultValue = [dateTimeStart, dateTimeEnd]
  const dateTimeType = filter.dateTime.type
  const dateTimeValue = filter.dateTime.value
  const dateTimeTrigger = filter.dateTime.trigger

  const handleDateTimeChange = data =>
    pageDispatch({
      type: studentActions.FILTER_HISTORY_DATE_TIME_UPDATE,
      payload: {
        end: data.value[1],
        start: data.value[0],
        type: data.category,
        value: data.formatValue,
      },
    })

  // ===== ===== ===== ===== =====
  // Payment Method
  // ===== ===== ===== ===== =====
  const paymentMethodActiveValue = filter.paymentMethod.activeValue
  const paymentMethodKeyword = filter.paymentMethod.keyword
  const paymentMethodList = filter.paymentMethod.list
  const paymentMethodListOrigin = filter.paymentMethod.listOrigin
  const paymentMethodValue = filter.paymentMethod.value

  const handlePaymentMethodChange = data =>
    pageDispatch({
      type: studentActions.FILTER_HISTORY_PAYMENT_METHOD_UPDATE,
      payload: { value: data },
    })

  const handlePaymentMethodKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const paymentMethodListData = paymentMethodListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: studentActions.FILTER_HISTORY_PAYMENT_METHOD_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: paymentMethodListData,
      },
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // Payment Status
  // ===== ===== ===== ===== =====
  const paymentStatusActiveValue = filter.paymentStatus.activeValue
  const paymentStatusKeyword = filter.paymentStatus.keyword
  const paymentStatusList = filter.paymentStatus.list
  const paymentStatusListOrigin = filter.paymentStatus.listOrigin
  const paymentStatusValue = filter.paymentStatus.value

  const handleSourceChange = data =>
    pageDispatch({
      type: studentActions.FILTER_HISTORY_PAYMENT_STATUS_UPDATE,
      payload: { value: data },
    })

  const handleSourceKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const paymentStatusListData = paymentStatusListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: studentActions.FILTER_HISTORY_PAYMENT_STATUS_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: paymentStatusListData,
      },
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== // ===== ===== ===== ===== =====
  // Product type
  // ===== ===== ===== ===== =====
  const productTypeActiveValue = filter.paymentStatus.activeValue
  const productTypeKeyword = filter.productType.keyword
  const productTypeList = filter.productType.list
  const productTypeListOrigin = filter.productType.listOrigin
  const productTypeValue = filter.productType.value

  const handleProductTypeChange = data => {
    pageDispatch({
      type: studentActions.FILTER_HISTORY_PRODUCT_TYPE_UPDATE,
      payload: { value: data },
    })
  }

  const handleProductTypeKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const productTypeListData = productTypeListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: studentActions.FILTER_HISTORY_PRODUCT_TYPE_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: productTypeListData,
      },
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // Student Status
  // ===== ===== ===== ===== =====
  const orderStatusActiveValue = filter.orderStatus.activeValue
  const orderStatusKeyword = filter.orderStatus.keyword
  const orderStatusList = filter.orderStatus.list
  const orderStatusListOrigin = filter.orderStatus.listOrigin
  const orderStatusValue = filter.orderStatus.value

  const handleWarehouseChange = data =>
    pageDispatch({
      type: studentActions.FILTER_HISTORY_ORDER_STATUS_UPDATE,
      payload: { value: data },
    })

  const handleWarehouseKeywordChange = data => {
    const formatDataValue = data?.value
      ? removeAcent(data?.value?.toLowerCase())
      : ''

    const orderStatusListData = orderStatusListOrigin.filter(item => {
      const formatNameItem = item?.name
        ? removeAcent(item.name.toLowerCase())
        : ''
      if (formatNameItem.includes(formatDataValue)) return true
      return false
    })

    pageDispatch({
      type: studentActions.FILTER_HISTORY_ORDER_STATUS_KEYWORD_UPDATE,
      payload: {
        keyword: data?.value || '',
        list: orderStatusListData,
      },
    })
  }

  // ===== ===== ===== ===== =====
  // ORDER ID
  // ===== ===== ===== ===== =====
  const orderIdValue = filter.orderId.value
  const orderIdActiveValue = filter.orderId.activeValue

  const handleStudentIdChange = value => {
    if (value === ' ') value = ''
    pageDispatch({
      type: studentActions.FILTER_HISTORY_ORDER_ID_UPDATE,
      payload: { value: value },
    })
  }
  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====

  // ===== ===== ===== ===== =====
  // PRODUCT
  // ===== ===== ===== ===== =====
  const productActiveValue = filter.product.activeValue
  const productValue = filter.product.value

  const handleProductChange = value => {
    if (value === ' ') value = ''
    pageDispatch({
      type: studentActions.FILTER_HISTORY_PRODUCT_UPDATE,
      payload: { value: value },
    })
  }

  // ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== ===== =====
  const canSubmitOtherFilter = [
    dateTimeActiveValue.value !== dateTimeValue ||
    JSON.stringify(dateTimeActiveValue.type) !== JSON.stringify(dateTimeType),
    JSON.stringify(paymentMethodActiveValue) !==
    JSON.stringify(paymentMethodValue),
    JSON.stringify(paymentStatusActiveValue) !== JSON.stringify(paymentStatusValue),
    JSON.stringify(orderStatusActiveValue) !== JSON.stringify(orderStatusValue),
    JSON.stringify(productActiveValue) !== JSON.stringify(productValue),
    JSON.stringify(orderIdActiveValue) !== JSON.stringify(orderIdValue),
    JSON.stringify(productTypeActiveValue) !== JSON.stringify(productTypeValue),
  ].includes(true)

  const queries = {
    date_type: dateTimeActiveValue?.type?.value || '',
    start_date:
      dateTimeActiveValue?.start && dateTimeActiveValue.value
        ? convertDateTimeToApiFormat(dateTimeActiveValue.value.split(' - ')[0])
        : '',
    end_date:
      dateTimeActiveValue?.end && dateTimeActiveValue.value
        ? convertDateTimeToApiFormat(dateTimeActiveValue.value.split(' - ')[1])
        : '',
    product_name: productActiveValue,
    type: productTypeActiveValue?.id,
    order_status: orderStatusActiveValue?.value || '',
    payment_status: paymentStatusActiveValue?.value || '',
    payment_method: paymentMethodActiveValue?.value || '',
    order_id: orderIdActiveValue || '',
    per_page: table?.pagination?.amount || 20,
    start: 0,
  }

  const applyStudentOtherFilter = async () => {
    const collection = {
      ...queries,
      date_type: dateTimeType?.value || '',
      type: productTypeValue?.id,
      start_date:
        dateTimeStart && dateTimeValue
          ? convertDateTimeToApiFormat(dateTimeValue.split(' - ')[0])
          : '',
      end_date:
        dateTimeEnd && dateTimeValue
          ? convertDateTimeToApiFormat(dateTimeValue.split(' - ')[1])
          : '',
      order_status: orderStatusValue?.value || '',
      payment_method: paymentMethodValue?.value || '',
      payment_status: paymentStatusValue?.value || '',
      product_name: productValue,
      order_id: orderIdValue || '',
    }
    fetchStudentByFilter(collection, { forceLoading: true })
  }

  const fetchStudentByFilter = async (qs, opt) => {
    setSearchParams('')
    if (Number.isNaN(opt?.activePage) || opt?.forceLoading)
      pageDispatch({
        type: studentActions.HISTORY_TABLE_DISPLAY_LOADING_UPDATE,
        payload: true,
      })

    let queryString = '?'
    let i = 0
    for (const [key, value] of Object.entries(qs)) {
      queryString += `${i > 0 ? '&' : ''}${key}=${value}`
      i++
    }

    const response = await Promise.all([
      sendRequestAuth('get', `${config.API}/teacher/customer/detail/${data?.zalo_id}/orders${queryString}&type=1`),
    ])

    if (!!response[0]?.data?.success) {
      pageDispatch({
        type: studentActions.OTHER_FILTER_HISTORY_APPLY,
        payload: {
          list: response[0].data.data
        },
      })
      pageDispatch({
        type: studentActions.HISTORY_TABLE_DISPLAY_LOADING_UPDATE,
        payload: false,
      })
    }
    pageDispatch({
      type: studentActions.HISTORY_TABLE_DISPLAY_LOADING_UPDATE,
      payload: false,
    })
  }

  const filterTagDeleteAll = isSoft => {
    STUDENT_FILTER_TAG_FIELDS.forEach(item =>
      pageDispatch({
        type: studentActions.TAG_FILTER_HISTORY_DELETE,
        payload: { type: item },
      }),
    )

    pageDispatch({
      type: studentActions.FILTER_HISTORY_DATE_TIME_TRIGGER_UPDATE,
      payload: {
        trigger: dateTimeTrigger === null ? true : !dateTimeTrigger,
      },
    })

    if (isSoft) return

    const collection = {
      ...queries,
      date_type: 'created',
      start_date: '',
      end_date: '',
      user_id: '',
      payment_method: '',
      product_name: '',
      type: '',
      payment_status: '',
      order_status: '',
      order_id: '',
    }

    fetchStudentByFilter(collection, { forceLoading: true })
  }

  return {
    dateTime: {
      activeValue: dateTimeActiveValue,
      defaultValue: dateTimeDefaultValue,
      disabledDate: afterToday(),
      triggerDefault: dateTimeTrigger,
      value: dateTimeValue,
      onChange: handleDateTimeChange,
    },
    product: {
      activeValue: productActiveValue,
      value: productValue,
      onChange: handleProductChange,
    },
    orderId: {
      value: orderIdValue,
      activeValue: orderIdActiveValue,
      onChange: handleStudentIdChange,
    },
    paymentMethod: {
      activeValue: paymentMethodActiveValue,
      keyword: paymentMethodKeyword,
      list: paymentMethodList,
      value: paymentMethodValue,
      onChange: handlePaymentMethodChange,
      onKeywordChange: handlePaymentMethodKeywordChange,
    },
    paymentStatus: {
      activeValue: paymentStatusActiveValue,
      keyword: paymentStatusKeyword,
      list: paymentStatusList,
      value: paymentStatusValue,
      onChange: handleSourceChange,
      onKeywordChange: handleSourceKeywordChange,
    },
    productType: {
      activeValue: productTypeActiveValue,
      keyword: productTypeKeyword,
      list: productTypeList,
      value: productTypeValue,
      onChange: handleProductTypeChange,
      onKeywordChange: handleProductTypeKeywordChange,
    },
    orderStatus: {
      activeValue: orderStatusActiveValue,
      keyword: orderStatusKeyword,
      list: orderStatusList,
      value: orderStatusValue,
      onChange: handleWarehouseChange,
      onKeywordChange: handleWarehouseKeywordChange,
    },
    canSubmitOtherFilter,
    queries,
    functions: {
      hasFilter: () => [
        JSON.stringify(dateTimeActiveValue?.value) !==
        JSON.stringify(studentInitialState.filter.dateTime.activeValue?.value),
        !!paymentMethodActiveValue?.name,
        !!paymentStatusActiveValue?.name,
        !!orderStatusActiveValue?.name,
        !!orderIdActiveValue,
      ].includes(true),
      applyStudentOtherFilter,
      refresh: () =>
        fetchStudentByFilter(
          {
            ...queries,
            type: 1,
            start: table.pagination.active * table.pagination.amount || 0,
          },
          { activePage: table.pagination.active, forceLoading: true },
        ),
      fetchUpdateData: () =>
        fetchStudentByFilter(
          {
            ...queries,
            type: 1,
            start: table.pagination.active * table.pagination.amount,
          },
          { activePage: table.pagination.active, notClearDetail: true },
        ),
      filterTagDeleteAll,
    },
  }
}
